module.exports = __webpack_public_path__ + "static/media/face-happy-fill.8bae2580.svg";